interface IDisabledFilterProps {
    filterName?: string;
}

export const DisabledFilter = ({ filterName }: IDisabledFilterProps) => {
    return <span>{filterName}</span>;
};
